module.exports = __webpack_public_path__ + "static/media/courses.5ba445d2.png";